import { apodization } from '../../../../apodization/apodization';
export function apodizationFilter(datum1D, options) {
    const { lineBroadening, gaussBroadening, lineBroadeningCenter } = options;
    const grpdly = datum1D.info?.digitalFilter || 0;
    const pointsToShift = grpdly > 0 ? Math.floor(grpdly) : 0;
    const re = datum1D.data.re;
    const im = datum1D.data.im;
    const t = datum1D.data.x;
    const length = re.length;
    const dw = (t[length - 1] - t[0]) / (length - 1); //REPLACE CONSTANT with calculated value... : for this we need AQ or DW to set it right...
    return apodization({ re, im }, {
        pointsToShift,
        compose: {
            length,
            shapes: [
                {
                    start: 0,
                    shape: {
                        kind: 'lorentzToGauss',
                        options: {
                            length,
                            dw,
                            exponentialHz: gaussBroadening > 0 ? lineBroadening : -lineBroadening,
                            gaussianHz: gaussBroadening,
                            center: lineBroadeningCenter,
                        },
                    },
                },
            ],
        },
    });
}
//# sourceMappingURL=apodizationFilter.js.map